export default __webpack_public_path__ + "static/media/instagram.0e6c31c6.svg";